
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire305e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire305e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jPxhr", function(module, exports) {

$parcel$export(module.exports, "formatPhoneNumber", () => $e6fc98820934cce0$export$842dcfa371c6bb83);
$parcel$export(module.exports, "formatPhone", () => $e6fc98820934cce0$export$10c09b2cff9813eb);
function $e6fc98820934cce0$export$842dcfa371c6bb83(inputField) {
    const phoneNumber = inputField.value.replace(/[^0-9]/g, ''); // clean the input
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber; // no formatting for less than 4 digits
    if (phoneNumberLength < 7) return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
}
function $e6fc98820934cce0$export$10c09b2cff9813eb(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    return null;
}

});


var $03cFT = parcelRequire("03cFT");

var $kcvY9 = parcelRequire("kcvY9");

var $jPxhr = parcelRequire("jPxhr");

var $cxph1 = parcelRequire("cxph1");
"use strict";
window.Webflow ||= [];
window.Webflow.push(async ()=>{
    const receiveOfferButton = document.getElementById('receiveOfferButton');
    const headerLabel = document.getElementById('headerLabel');
    const bottomLabel = document.getElementById('bottomLabel');
    const progressModal = document.getElementById('progressModal');
    const verifyModal = document.getElementById('verifyModal');
    const verifyTopLabel = document.getElementById('verifyTopLabel');
    const verifyPhoneTextField = document.getElementById('verifyPhoneTextField');
    const resendCodeButton = document.getElementById('resendCodeButton');
    const verifySmsButton = document.getElementById('verifySmsButton');
    const closeVerifyButton = document.getElementById('closeVerifyButton');
    var referralId;
    var initialamount = 15;
    var locationObject = await (0, $kcvY9.LocationObject)();
    function setUpHeaderLabel() {
        const currentUser = (0, $03cFT.default).User.current();
        if (currentUser != null) {
            const firstName = currentUser.get('firstname');
            if (firstName != null) {
                headerLabel.innerText = "HEY " + firstName.toUpperCase() + ", HERE'S 15% OFF ONE ORDER";
                bottomLabel.innerText = "REQUIRED TO VERIFY PHONE NUMBER TO RECEIVE OFFER";
                receiveOfferButton.innerText = "ADD OFFER TO BOX";
            } else {
                headerLabel.innerText = "15% OFF ONE ORDER";
                bottomLabel.innerText = "REQUIRED TO CREATE ACCOUNT AND VERIFY PHONE NUMBER TO RECEIVE OFFER";
                receiveOfferButton.innerText = "CREATE ACCOUNT";
            }
        } else {
            headerLabel.innerText = "15% OFF ONE ORDER";
            bottomLabel.innerText = "REQUIRED TO CREATE ACCOUNT AND VERIFY PHONE NUMBER TO RECEIVE OFFER";
            receiveOfferButton.innerText = "CREATE ACCOUNT";
        }
    }
    setUpHeaderLabel();
    receiveOfferButton.addEventListener('click', async ()=>{
        const initialActive = locationObject.get('initialofferbool');
        if (initialActive) {
            const currentUser = (0, $03cFT.default).User.current();
            if (currentUser != null) {
                const anonymous = currentUser.get('anonymous');
                if (!anonymous) {
                    const phone = currentUser.get('phonenumber');
                    setUpPhoneVerify(phone);
                } else {
                    sessionStorage.setItem('offer', 'Welcome15');
                    (0, $cxph1.goToNextPage)('/create-account');
                }
            } else {
                sessionStorage.setItem('offer', 'Welcome15');
                (0, $cxph1.goToNextPage)('/create-account');
            }
        } else alert('Offer is no longer available');
    });
    // MARK: - VERIFY PHONE
    var phoneNumber;
    var codeSent = false;
    $("#verifyForm").submit(()=>{
        return false;
    });
    function setUpPhoneVerify(phone) {
        phoneNumber = phone;
        verifyPhoneTextField.value = (0, $jPxhr.formatPhone)(phone);
        verifyTopLabel.innerText = 'EARN ' + initialamount + '% OFF ONE ORDER - VALID ONE TIME PER CUSTOMER';
        verifyModal.style.display = 'flex';
    }
    resendCodeButton.addEventListener('click', async ()=>{
        resetView();
    });
    verifySmsButton.addEventListener('click', async ()=>{
        if (codeSent === false) {
            phoneNumber = verifyPhoneTextField.value.replace(/\D/g, '');
            var error = '';
            if (phoneNumber.length != 10) error = 'Please enter full 10 digits';
            if (error != '') alert(error);
            else checkPhoneNumber(phoneNumber);
        } else {
            // verify with code
            const code = verifyPhoneTextField.value;
            var error = '';
            if (code.length != 6) error = 'Please enter 6 digit code sent in SMS';
            if (error != '') alert(error);
            else verifyPhoneNumber(phoneNumber, code);
        }
    });
    closeVerifyButton.addEventListener('click', async ()=>{
        verifyModal.style.display = 'none';
    });
    async function verifyPhoneNumber(phone, code) {
        progressModal.style.display = 'flex';
        try {
            const status = await (0, $03cFT.default).Cloud.run('verifyTextCodeWeb', {
                'phone': phone,
                'code': code
            });
            if (status === 'approved') {
                const request = {
                    'phone': phoneNumber,
                    'initialamount': initialamount,
                    'locationid': (0, $kcvY9.default)
                };
                await (0, $03cFT.default).Cloud.run('updateUserVerificationAndRefferal', request);
                const currentUser = (0, $03cFT.default).User.current();
                if (currentUser != null) await currentUser.fetch();
                sessionStorage.removeItem("offer");
                alert('Success! 15% will be applied at check out - expires in 7 days');
                (0, $cxph1.goToNextPage)('/profile');
            } else alert('Code failed please try again');
        } catch (e) {
            alert(e.message);
        }
        progressModal.style.display = 'none';
    }
    async function checkPhoneNumber(phone) {
        progressModal.style.display = 'flex';
        try {
            const available = await (0, $03cFT.default).Cloud.run('checkPhoneNumber', {
                "phone": phone
            });
            if (available == true) await sendCode(phone);
            else alert('Offer already redeemed by this phone number');
        } catch (e) {
            alert(e.message);
        }
        progressModal.style.display = 'none';
    }
    async function sendCode(phone) {
        const status = await (0, $03cFT.default).Cloud.run('sendTextVerificationWeb', {
            "phone": phone
        });
        if (status === "pending") {
            verifyPhoneTextField.value = '';
            verifyPhoneTextField.placeholder = 'Enter Code';
            verifyTopLabel.innerText = 'ENTER 6 DIGIT CODE';
            resendCodeButton.style.display = 'block';
            verifySmsButton.value = 'VERIFY';
            verifyPhoneTextField.focus();
            codeSent = true;
        } else alert('Code failed to send');
    }
    async function resetView() {
        verifyPhoneTextField.value = (0, $jPxhr.formatPhone)(phoneNumber);
        verifyTopLabel.innerText = 'TO RECEIVE THIS OFFER YOU MUST VERIY PHONE NUMBER VIA SMS';
        resendCodeButton.style.display = 'none';
        verifySmsButton.value = 'SEND SMS CODE';
        codeSent = false;
        verifyTopLabel.innerText = 'EARN ' + initialamount + '% OFF ONE ORDER';
        if (referralId != null) verifyTopLabel.innerText = 'EARN ' + initialamount + '% OFFER FROM YOUR FRIEND';
    }
});


//# sourceMappingURL=download-app.0932a3c5.js.map
